/* Hook encargado de hacer posts a la organization
Autor: Benjamín León
Fecha: 2024-03-01
*/
import { useState } from 'react'

import { Articles, Delegate } from '../interfaces/OrganizationDto.ts'
import { customPost } from '../utils/customFetch.ts'
import { normalizeDate } from '../utils/utils.ts'

import { makeUrlOrganizationDelegatesCrea, makeUrlOrganizationConsignmentDefaultsCrea } from './connectionData.tsx'

const useOrganizationPoster = () => {
  const [errorOrganizationPoster, setErrorOrganizationPoster] = useState<Error | null>(null)
  const [loadingOrganization, setLoadingOrganization] = useState<boolean>(false)

  const organizationDelegatesCrea = async (organizationId: string, delegates: Delegate[], articles: Articles) => {
    setLoadingOrganization(true)

    try {
      const articlesNew = { ...articles, date: normalizeDate(articles.date) }
      const apiParams = { organizationId: organizationId, delegates: delegates, articles: articlesNew }

      const apiUrl = makeUrlOrganizationDelegatesCrea()

      const data = await customPost(apiUrl, apiParams)
      setErrorOrganizationPoster(null)

      return data
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorOrganizationPoster(err)
      } else {
        setErrorOrganizationPoster(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoadingOrganization(false)
    }
  }

  const organizationConsignmentDefaultsCrea = async (
    organizationId: string,
    minimum?: number,
    fee?: number,
    charge?: number,
    city?: string
  ) => {
    setLoadingOrganization(true)

    try {
      const apiParams = { organizationId, minimum, fee, charge, city }
      const apiUrl = makeUrlOrganizationConsignmentDefaultsCrea()

      const data = await customPost(apiUrl, apiParams)
      setErrorOrganizationPoster(null)

      return data
    } catch (err) {
      if (err instanceof Error) {
        setErrorOrganizationPoster(err)
      } else {
        setErrorOrganizationPoster(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoadingOrganization(false)
    }
  }

  // Exponemos estas variables al exterior
  return {
    errorOrganizationPoster,
    loadingOrganization,
    organizationDelegatesCrea,
    organizationConsignmentDefaultsCrea,
  }
}

export default useOrganizationPoster
